
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestfloorcleaningmachines/privacy-policy",
      function () {
        return require("private-next-pages/bestfloorcleaningmachines/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestfloorcleaningmachines/privacy-policy"])
      });
    }
  